import { computed, Ref } from '@vue/composition-api';
import { NetStateEnum, useStore } from '@tt4b/ttam-hooks';
import { OffLineEvents } from '@tt4b/ttam-enums';

export function useOfflineEventsList() {
  const { getStore } = useStore();

  const {
    run: loadData,
    data,
    isLoading,
    hasLoaded,
  } = getStore(NetStateEnum.offlineEventsList, undefined, false, false);
  const oriOfflineEventsList = computed(() => data.value || []);
  const oriAutoTrackingEventsList = computed(() =>
    (oriOfflineEventsList.value?.length ? oriOfflineEventsList.value : []).filter(event => Boolean(event.autoTracking)),
  );
  async function loadOfflineEventsList() {
    await loadData();
    return oriOfflineEventsList.value;
  }

  return {
    loading: isLoading,
    oriOfflineEventsList,
    oriAutoTrackingEventsList,
    loadOfflineEventsList,
    hasLoaded,
  };
}
